import React from 'react';
import Immutable from 'immutable';

import { Taxonomy } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { TaxonomyThemes } from '../../../types/uncinc_profile/taxonomy';

import './style.scss';

interface ViewThemesByParentProps {
  entities: Immutable.List<ImmutableEntity<TaxonomyThemes>>;
}

const ViewThemesByParent: React.FC<ViewThemesByParentProps> = ({
  entities,
}) => (
  <div className="ViewThemesByParent">
    {entities.map((entity) => {
      const theme = entity.toJS();
      const uuid = theme.uuid[0].value;
      const langcode = theme.langcode[0].value;
      const key = `${uuid}:${langcode}`;

      return (
        <Taxonomy
          entity={entity}
          key={key}
          viewMode="teaser"
        />
      );
    })}
  </div>
);

export default ViewThemesByParent;
